export default __webpack_public_path__ + "static/media/icon-prev.f72bba8e.svg";